"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADOBE_TARGET_PRESOLDEN = void 0;
exports.ADOBE_TARGET_PRESOLDEN = 'presolden';
